// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3apvo","right":"styles_right__2w5S8"};